/**
 * Check if a user is authenticated.
 *
 * @param {object} user
 *
 * @returns {boolean}
 */
export default (user) => {
    if (!user) {
        return false;
    }
    return user && user.authenticated === true;
};
